import { Animation } from "./atoms/Animation";

function LoadingOverlay() {
  return (
    <div className="fixed left-0 top-0 z-40 flex h-full w-full items-center justify-center bg-offwhite">
      <Animation type="ringRotate" height={500} width={500} />
    </div>
  );
}

export { LoadingOverlay };
